<template>
  <v-icon
    small
    left
    class="close-icon"
    :color="on ? 'green' : 'grey'"
    @click="$emit('edit')"
    outline
    >{{ on ? 'mdi-check' : 'mdi-pencil' }}</v-icon
  >
</template>

<script>
export default {
  name: 'BtnEdit',
  props: {
    on: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
}
</script>
